import { FunctionComponent, useEffect } from 'react';
import css from './TribesList.module.less';
import { Pagination, Spin } from 'antd';
import TribesPost from '../TribesPost/TribesPost';
import { useStore } from 'effector-react';
import tribes, { getList, reset, setFilters, setPagination } from '@stores/tribes';
import { pageSizeOptions } from '@constants/pagination';
import { TribesFiltersValue } from '@helpers/tribesFilters';

interface TribesListProps {
  filters: TribesFiltersValue;
}

const TribesList: FunctionComponent<TribesListProps> = ({ filters }) => {
  const { list, preloaders, pagination } = useStore(tribes);

  const paginationChange = (current: number, pageSize?: number) => {
    setPagination({ ...pagination, current, pageSize });
    getList();
  };

  useEffect(() => {
    setFilters(filters);
    setPagination({ ...tribes.getState().pagination, current: 1 });
    getList();
  }, [filters]);

  useEffect(() => () => reset(), []);

  useEffect(() => {
    if (preloaders.deleteTribe === false) getList();
  }, [preloaders.deleteTribe]);

  return (
    <>
      <div className={css.paginationContainer}>
        <Pagination
          {...pagination}
          showQuickJumper
          showSizeChanger
          onChange={paginationChange}
          pageSizeOptions={pageSizeOptions}
        />
      </div>
      <Spin spinning={!!preloaders.getList}>
        <div>
          {list.map((tribes, index) => (
            <TribesPost
              key={index}
              tribes={tribes}
            />
          ))}
        </div>
      </Spin>
      <div className={css.paginationContainer}>
        <Pagination
          {...pagination}
          showQuickJumper
          showSizeChanger
          onChange={paginationChange}
          pageSizeOptions={pageSizeOptions}
        />
      </div>
    </>
  );
};

export default TribesList;
